
import { computed, defineAsyncComponent, defineComponent } from 'vue';

export default defineComponent({
  name: 'CustomContainer',
  props: {
    comp: {
      type: Object,
      default: () => ({})
    }
  },
  setup () {
    const dycComponent = computed(() => {
      return (component) => {
        return defineAsyncComponent(() => import('@/asyncComponents/' + component + '.vue'))
      }
    })
    return {
      dycComponent
    }
  }
})
